import {Theme, useMediaQuery} from '@mui/material';

export function useMediaQueries() {
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
	const isTablet = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
	const isLaptop = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
	const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
	const aboveTablet = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
	const aboveMobile = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
	const betweenMobileAndLaptop = useMediaQuery((theme: Theme) =>
		theme.breakpoints.between('sm', 'md'),
	);
	const betweenMobileAndDesktop = useMediaQuery((theme: Theme) =>
		theme.breakpoints.between('sm', 'lg'),
	);
	const betweenMobileAndTablet = useMediaQuery((theme: Theme) =>
		theme.breakpoints.between('sm', 'md'),
	);
	const largerDevices = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));

	const smallerDevices = useMediaQuery((theme: Theme) => theme.breakpoints.down(375));

	return {
		isDesktop,
		isLaptop,
		isTablet,
		isMobile,
		aboveTablet,
		betweenMobileAndLaptop,
		betweenMobileAndDesktop,
		betweenMobileAndTablet,
		aboveMobile,
		largerDevices,
		smallerDevices,
	};
}
